import React from 'react';
import { AlertCircle, ExternalLink } from 'lucide-react';
import { Button } from '../ui/button';
import { Card, CardContent } from '../ui/card';
interface ErrorMessageProps {
  message: string;
  onRetry?: () => void;
}
export function ErrorMessage({
  message,
  onRetry
}: ErrorMessageProps) {
  // Check if the message is about CORS proxy activation
  const isCorsProxyError = message.includes('CORS Proxy requires activation') || message.includes('corsdemo');
  const handleActivateCorsProxy = () => {
    window.open('https://cors-anywhere.herokuapp.com/corsdemo', '_blank');
  };
  return <Card className="border-destructive/20 bg-destructive/5" data-id="element-1342">
      <CardContent className="p-6 text-center" data-id="element-1343">
        <AlertCircle size={48} className="mx-auto text-destructive mb-4" data-id="element-1344" />
        <h3 className="text-lg font-medium mb-2" data-id="element-1345">Error Loading Data</h3>
        {isCorsProxyError ? <>
            <p className="text-muted-foreground mb-4" data-id="element-1346">
              The CORS proxy service requires temporary activation before it can
              be used.
            </p>
            <div className="flex flex-col gap-3 items-center" data-id="element-1347">
              <Button onClick={handleActivateCorsProxy} className="flex items-center" data-id="element-1348">
                <ExternalLink size={16} className="mr-2" data-id="element-1349" />
                Activate CORS Proxy
              </Button>
              <p className="text-sm text-muted-foreground" data-id="element-1350">
                After activation, come back here and click retry
              </p>
              {onRetry && <Button onClick={onRetry} variant="outline" className="mt-2" data-id="element-1351">
                  Retry
                </Button>}
            </div>
          </> : <>
            <p className="text-muted-foreground mb-4" data-id="element-1352">{message}</p>
            {onRetry && <Button onClick={onRetry} data-id="element-1353">Try Again</Button>}
          </>}
      </CardContent>
    </Card>;
}